import { http } from "../../lib/api";

// Yetkili indirme: dosyayı blob olarak çekip tarayıcıya kaydettirir
export async function downloadBlob(path, fileName) {
  const r = await http.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = fileName || "dosya"; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

// Yetkili görüntüleme: sekme tıklama anında açılır (popup engelleyici takılmaz), PDF blob olarak çekilip tarayıcı görüntüleyicisine verilir
export async function openBlob(path, fileName) {
  const w = window.open("", "_blank");
  try {
    const r = await http.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([r.data], { type: r.data.type || "application/pdf" }));
    if (w) w.location.href = url;
    else { const a = document.createElement("a"); a.href = url; a.download = fileName || "dosya"; a.click(); }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) { w?.close(); throw e; }
}
